import { createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../constants/apiRoutes";
import { paymentsAPI } from "../../../constants/reduxConstant";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import rollbar from "../../../rollbarConfig";

const {
    get_earnings = "",
} = paymentsAPI;
const {
  V1: {
    GET_SELLER_EARNINGS,
  } = {},
} = API_ROUTES;

const fetchEarnings = createAsyncThunk(get_earnings, async (_, { dispatch, getState }) => {
  const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
  try {
    dispatch(updateLoading(true));
    const response = await API.get(GET_SELLER_EARNINGS);
    return response?.data;
  } catch (err) {
    rollbar.error("Error message", err);    
    return err;
  } finally {
    dispatch(updateLoading(false));
  } 
});

export { fetchEarnings };
